module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/reserved_order_index-9dba2a7f395c2d77dd5cef57ca3bf470.png";